import React from 'react';
import {
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

import { adminTableMemberGridStyles } from './adminTableMemberGridStyles';
import { adminTableStyles } from './adminTableStyles';

export interface AdminTableNameEmailRowProps {
  name: string;
  email: string;
  testID?: string;
  accessibilityLabel?: string;
  trailing?: React.ReactNode;
  rowStyle?: StyleProp<ViewStyle>;
  emailAlign?: 'right' | 'center';
  onPress?: () => void;
  disabled?: boolean;
}

export const AdminTableNameEmailRow: React.FC<AdminTableNameEmailRowProps> = ({
  name,
  email,
  testID,
  accessibilityLabel,
  trailing,
  rowStyle,
  emailAlign = 'right',
  onPress,
  disabled = false,
}) => {
  const rowContent = (
    <>
      <Text style={adminTableStyles.primaryCell} numberOfLines={1}>
        {name}
      </Text>
      <Text
        style={[
          adminTableStyles.secondaryCell,
          emailAlign === 'center'
            ? adminTableMemberGridStyles.emailCellCentered
            : adminTableMemberGridStyles.rightAligned,
        ]}
        numberOfLines={1}
      >
        {email}
      </Text>
      {trailing ? (
        <View style={adminTableMemberGridStyles.actionsColumn}>{trailing}</View>
      ) : null}
    </>
  );

  if (onPress) {
    return (
      <TouchableOpacity
        style={[
          adminTableStyles.row,
          adminTableMemberGridStyles.gridRow,
          rowStyle,
          disabled && adminTableMemberGridStyles.rowAddButtonDisabled,
        ]}
        testID={testID}
        accessibilityLabel={accessibilityLabel ?? `Add ${name}`}
        accessibilityRole="button"
        onPress={onPress}
        disabled={disabled}
        activeOpacity={0.7}
      >
        {rowContent}
      </TouchableOpacity>
    );
  }

  return (
    <View
      style={[
        adminTableStyles.row,
        adminTableMemberGridStyles.gridRow,
        rowStyle,
      ]}
      testID={testID}
      accessibilityLabel={accessibilityLabel}
    >
      {rowContent}
    </View>
  );
};
